export const categoryCards = [
  {
    id: 1,
    name: "Wires And Cables",
    image: "https://ik.imagekit.io/raghav11/wires%20and%20cables.jpg?updatedAt=1763041770432",
    alt: "Wires & Cables products"
  },
  {
    id: 2,
    name: "Light",
    image: "https://ik.imagekit.io/raghav11/Gemini_Generated_Image_foq62jfoq62jfoq6.png?updatedAt=1763041582382",
    alt: "Paint products"
  },
  {
    id: 3,
    name: "MCBs & DBs",
    image: "https://ik.imagekit.io/raghav11/mcbsdb.png",
    alt: "MCBs & DBs products"
  },
  {
    id: 4,
    name: "Switches-Sockets",
    image: "https://ik.imagekit.io/raghav11/Gemini_Generated_Image_8lvirt8lvirt8lvi.png?updatedAt=1763041482483",
    alt: "Switches products"
  }
];

export const categoryProductCards = [
  {
    id: 1,
    name: "Ultra Tech Cement 50kg (1 pack)",
    image: "https://ik.imagekit.io/raghav11/download.jpg?updatedAt=1757934662868",
    alt: "Ultra Tech Cement",
    slug: "ultra-tech-cement-50kg"
  },
  {
    id: 2,
    name: "Birla white (White Cement) 1Kg",
    image: "https://ik.imagekit.io/raghav11/download.jpg?updatedAt=1757934662868",
    alt: "Birla White Cement",
    slug: "birla-white-cement-1kg"
  },
  {
    id: 3,
    name: "Floor Mopping",
    image: "https://ik.imagekit.io/raghav11/download.jpg?updatedAt=1757934662868",
    alt: "Floor Mopping Service",
    slug: "floor-mopping"
  },
  {
    id: 4,
    name: "Tiling floor (repair)",
    image: "https://ik.imagekit.io/raghav11/download.jpg?updatedAt=1757934662868",
    alt: "Tiling Repair Service",
    slug: "tiling-floor-repair"
  }
];

export const categoryHeading = "Light Up Your Homes in Minutes";
